import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({});

export const PageNotFound = withStyles(styles)(props => {
  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <div style={{
        marginBottom: 25,
        marginTop: -100,
        fontSize: '5em',
        fontWeight: 'bold',
        color: 'var(--jmi-blue)',
      }}>404</div>
      <div>
        Sorry, but the page you requested either does not exist or you do not have the proper permissions to view it.
      </div>
    </div>
  );
});
